<template>
  <q-dialog ref="dialog" @hide="onDialogHide">
    <q-card
      class="error text-center full-width q-pt-md q-pb-sm border-radius-8"
    >
      <q-card-section class="q-pt-none">
        <q-circular-progress
          :thickness="0.25"
          indeterminate
          size="40px"
          color="primary"
        />
        <div class="text-weight-bolder font-size-16 q-pt-sm">
          <span>{{ title }}</span>
        </div>
        <div v-if="describe" class="font-size-16 q-pt-sm">
          <span>{{ describe }}</span>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    describe: {
      type: String,
      default: '',
    },
    okText: {
      type: String,
      default: '',
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
  },
  methods: {
    // 以下方法是必需的 (不要改变它的名称 --> "show")
    show() {
      this.$refs.dialog.show();
    },
    // 以下方法是必需的 (不要改变它的名称 --> "hide")
    hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide() {
      // QDialog发出“hide”事件时
      // 需要发出
      this.$emit('hide');
    },
  },
};
</script>
